"use client";
import { useEffect } from "react";
import useSuggester from "../../common/utils/useSuggester";

export default function SuggesterTrackerSink({
  product,
  assortment,
  content,
}: {
  product?: any;
  assortment?: any;
  content?: any;
}) {
  const { storeVisitedProduct, storeVisitedCategory, storeVisitedContent } =
    useSuggester();

  useEffect(() => {
    if (product) {
      storeVisitedProduct(product);
    }
  }, [storeVisitedProduct, product]);

  useEffect(() => {
    if (assortment) {
      storeVisitedCategory(assortment);
    }
  }, [storeVisitedCategory, assortment]);

  useEffect(() => {
    if (content) {
      storeVisitedContent(content);
    }
  }, [storeVisitedContent, content]);

  return null;
}
